import {H2, PNoMargin} from '@/typography';
import {Row, Col} from '@/grid';
import {withMarginBottomSm, withMarginBottomZeroToLg} from '@/hocs/withSpacing';
import {withGreen300, withNeutral50} from '@/hocs/withColors';
import {withBoldWeight} from '@/hocs/withFontType';

const StatisticText = withBoldWeight(withMarginBottomZeroToLg(withNeutral50(PNoMargin)));
const GreenH2 = withGreen300(H2);
const DivSpace = withMarginBottomSm('div');

const StatsArray = [
  {
    number: '40 days',
    copy: 'average time to hire'
  },
  {
    number: '20%',
    copy: 'improved quality of hires'
  },
  {
    number: '30%',
    copy: 'increased hr productivity'
  },
  {
    number: '100%',
    copy: 'removal of agency/third-party tools costs'
  }
];

const StatsCols = () => (
  <DivSpace>
    <Row center="xs">
      {StatsArray.map(({number, copy}, index) => (
        <Col lg={3} xs={12} md={4} key={index}>
          <GreenH2>{number}</GreenH2>
          <StatisticText>{copy}</StatisticText>
        </Col>
      ))}
    </Row>
  </DivSpace>
);

export default StatsCols;
